import React, { Component } from 'react';
import { Alert } from 'react-bootstrap';

class ErrorMessage extends Component {
  render() {
    const { title, text } = this.props;
    return (
      <Alert bsStyle="danger">
        {title ? (
          <span>
            <strong>{title}</strong>
            <br />
          </span>
        ) : null}
        {text}
      </Alert>
    );
  }
}
export default ErrorMessage;
